import utils from './utils';
import { Select } from 'antd';
import { useSelector } from "react-redux";


const AggregationPeriodSelect = ({ value = null, onChange, multiple = false  }) => {

    const handleChange = (vak) => {
        onChange?.(vak);
    };

    return (
        <Select
            showSearch
            placeholder="Izberi obdobje"
            optionFilterProp="label"
            options={[
                {
                    'label': 'Leto',
                    'value': 'year'
                },
                {
                    'label': 'Četrtletje',
                    'value': 'quarter'
                },
                {
                    'label': 'Mesec',
                    'value': 'month'
                },
                {
                    'label': 'Teden',
                    'value': 'week'
                },
                {
                    'label': 'Dan',
                    'value': 'day'
                }
            ]}
            value={value}
            onChange={handleChange}
        />
    );
}

export default AggregationPeriodSelect;
